import { Nullable } from 'utils/types';

export enum FIELDS {
  POSTCODE = 'postcode',
  FLAT_NUMBER = 'flatNumber',
  BUILDING_NAME = 'buildingName',
  BUILDING_NUMBER = 'buildingNumber',
  STREET = 'street',
  CITY = 'city',
  COUNTY = 'county',
  FULL_ADDRESS = 'fullAddress',
}

export type AddressType = {
  [FIELDS.POSTCODE]: Nullable<string>;
  [FIELDS.FLAT_NUMBER]: Nullable<string>;
  [FIELDS.BUILDING_NAME]: Nullable<string>;
  [FIELDS.BUILDING_NUMBER]: Nullable<string>;
  [FIELDS.STREET]: Nullable<string>;
  [FIELDS.CITY]: Nullable<string>;
  [FIELDS.COUNTY]: Nullable<string>;
};

export type PickableAddress = {
  relatedAddresses: AddressType[];
  onAddressSelect: (prefix: string, address: AddressType) => void;
};
